import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { getPathWithParam } from "../../utils";
import tenantConfig from "../../mocks/tenantOne.json";
import authorization from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";
const ManageMaintenanceMenu = ({
  menuList = [],
  selectedMenu,
  flow,
  eligibilityId,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <ul className="manage-company-menu">
      {menuList.map((item) => {
        const childRoutes = get(item, "childRoutes", []);
        let className =
          selectedMenu.indexOf(item.path) !== -1 ||
          childRoutes.filter((route) => {
            return selectedMenu.indexOf(route) !== -1;
          }).length
            ? "selected"
            : "";

        return (
          tenantConfig.maintenanceSubMenu.includes(item.id) &&
          authorization[roleName].maintenanceSubMenu[item.id] && (
            <li key={item.path} className={`${className} has-tick`}>
              <FontAwesomeIcon icon={faCheckCircle} size="1x" />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Link
                to={getPathWithParam({
                  path: item.path,
                })}
              >
                {item.label}
              </Link>
              <span className="open-rounded-corner-top" />
              <span className="open-rounded-corner-bottom" />
            </li>
          )
        );
      })}
    </ul>
  );
};

export default ManageMaintenanceMenu;
